import clsx from 'clsx'

type Props = {
  page: number
  totalPages: number
  onChange: (page: number) => void
  loading?: boolean
}

export const Pagination = ({page, totalPages, onChange, loading = false}: Props) => {
  const getPages = () => {
    const pages: (number | string)[] = []

    if (totalPages <= 7) {
      return Array.from({length: totalPages}, (_, i) => i + 1)
    }

    pages.push(1)

    if (page > 4) {
      pages.push('...')
    }

    const start = Math.max(2, page - 2)
    const end = Math.min(totalPages - 1, page + 2)

    for (let i = start; i <= end; i++) {
      pages.push(i)
    }

    if (page < totalPages - 3) {
      pages.push('...')
    }

    pages.push(totalPages)

    return pages
  }

  const pages = getPages()

  return (
    <div className='d-flex justify-content-end mt-5'>
      <ul className='pagination'>
        <li className={clsx('page-item', {disabled: page === 1 || loading})}>
          <button
            type='button'
            className='page-link'
            onClick={() => onChange(page - 1)}
            disabled={page === 1 || loading}
          >
            {'<'}
          </button>
        </li>

        {pages.map((p, index) => (
          <li
            key={`${p}-${index}`}
            className={clsx('page-item', {
              active: page === p,
              disabled: loading || p === '...',
            })}
          >
            <button
              type='button'
              className='page-link'
              onClick={() => typeof p === 'number' && onChange(p)}
              disabled={loading || p === '...'}
            >
              {p}
            </button>
          </li>
        ))}

        <li className={clsx('page-item', {disabled: page === totalPages || loading})}>
          <button
            type='button'
            className='page-link'
            onClick={() => onChange(page + 1)}
            disabled={page === totalPages || loading}
          >
            {'>'}
          </button>
        </li>
      </ul>
    </div>
  )
}
